'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromValue = exports.fromKey = undefined;
exports.default = morphey;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _from = require('./from');

var _from2 = _interopRequireDefault(_from);

var _fromValue2 = require('./from-value');

var _fromValue3 = _interopRequireDefault(_fromValue2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setIn(obj, key, value) {
  return (0, _set2.default)((0, _cloneDeep2.default)(obj), key, value);
}

exports.fromKey = _from2.default;
exports.fromValue = _fromValue3.default;
function morphey(obj, translations) {
  var finalTranslations = typeof translations === 'function' ? translations(obj) : translations;
  return Object.keys(finalTranslations).reduce(function (result, k) {
    var originalKey = finalTranslations[k];
    if (!originalKey) {
      return result;
    }
    if (typeof originalKey === 'string') {
      // newKey: 'oldKey'
      var value = (0, _get2.default)(obj, originalKey);
      return setIn(result, k, value);
    } else if (originalKey.isFromValue) {
      return setIn(result, k, originalKey.value);
    } else if (originalKey.isFromKey || originalKey.hasOwnProperty('fromKey')) {
      // newKey: { fromKey: 'oldKey' }
      var fromKey = originalKey.fromKey,
          transform = originalKey.transform;

      var _value = (0, _get2.default)(obj, fromKey);
      return setIn(result, k, typeof transform === 'function' ? transform(_value) : _value);
    } else if (originalKey.hasOwnProperty('value')) {
      var _value2 = originalKey.value;

      return setIn(result, k, _value2());
    } else {
      throw new Error('Only "strings" and "objects" can be used as translation values. Received ' + originalKey + ' for key ' + k);
    }
  }, {});
};